import { DollarSign } from 'lucide-react';

interface ClientBillingProps {
  clientId: string;
}

export function ClientBilling({ clientId: _clientId }: ClientBillingProps) {
  // TODO: Implement billing management
  // - Fetch billing via GET /api/portal/clients/{id}/billing
  // - Update subscription via PUT /api/portal/clients/{id}/billing/subscription
  // - Display subscription tier, billing cycle, payment status

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-2xl font-bold text-slate-100">Billing</h2>
          <p className="mt-1 text-sm text-slate-400">Manage client subscription and billing</p>
        </div>
      </div>

      {/* Placeholder */}
      <div className="bg-slate-800/50 backdrop-blur-sm rounded-lg border border-slate-700 p-12 text-center">
        <DollarSign className="mx-auto h-12 w-12 text-slate-600" />
        <h3 className="mt-2 text-sm font-semibold text-slate-300">Billing management coming soon</h3>
        <p className="mt-1 text-sm text-slate-500">
          This feature will be implemented in Phase 7
        </p>
      </div>
    </div>
  );
}
